import {
  DigitalMenuQrCodeInterface,
  DigitalMenuQrCodeTextInterface,
} from "@/interface/business/digital-menu.interface";
import { DigitalMenuQrCodeText } from "@/modules/business/digital";

export default class DigitalMenuQrCode implements DigitalMenuQrCodeInterface {
  background_color: string = "";
  color: string = "";
  url: string = "";
  text!: DigitalMenuQrCodeTextInterface;
  constructor(data?) {
    Object.assign(this, data);
    this.background_color = data?.background_color || "#E0F6FF";
    this.color = data?.color || "#2D415A";
    this.url = data?.url || process.env.VUE_APP_DIGITAL_MENU_DOMAIN_URL;
    this.text = new DigitalMenuQrCodeText(data?.text);
  }
}
